import React from "react";
import PropTypes from "prop-types";
import Section from "../common/Section";
import Form from "../common/Form";
import * as domainConstants from '../../constants/DomainConstants';
import * as types from "../../constants/ComponentConstants";
import Row from "../common/Row";
import TextInput from "../common/TextInput";
import SelectInput from "../common/SelectInput";
import Dropdown from "../common/Dropdown";
import Button from "../common/Button";
import Fieldset from "../common/Fieldset";
import Tooltip from "../common/Tooltip";
import Map from "../common/map/Map";
import Markers from "../common/map/Markers";
import { Circle } from 'react-leaflet';

const SimulatiePerInfrastructuurEditInfrastructuurForm = (props) => {
    const {
        model,
        color,
        isNew,
        isSpakki,
        onChange,
        soortenInfrastructuur,
        gemeenten,
        postcodes,
        mapKey,
        mapEditMode,
        mapCenter,
        mapNewCoords,
        onSave,
        onCancel,
        onReplacePoint,
        onSaveNewPoint,
        onCancelReplace,
        onGetGeoCoordinates,
        errors,
        infrastructuurAanvraagCoordinaten,
        hideAndereSoortInfrastructuur,
        center,
        geoToolboxUrl,
        maxMapFeaturesToLoad,
        osmBaseLayerUrl,
        onMarkerDragEnd,
        validationMessageType
    } = props;

    const formTitle = isNew ? "Voeg ontbrekende sportinfrastructuren in de buurt toe" : "Wijzig sportinfrastructuur " + model.naam;

    const soortenInfrastructuurList = (hideAndereSoortInfrastructuur ? soortenInfrastructuur.filter((x, i) => i > 0) : soortenInfrastructuur).map((soortInfrastructuurObject) => {
        return {
            value: soortInfrastructuurObject.id,
            label: soortInfrastructuurObject.description,
            text: soortInfrastructuurObject.description
        };
    });

    const wijzigMapTooltip = "Het is zeer belangrijk dat de aangevraagde infrastructuur aangeduid is exact op de plaats waar deze zal gerealiseerd worden. Dit is het midden van de sportinfrastructuur.";

    const showMap = mapCenter ? true : false;

    let aanvraagCoordinaten = null;
    if (showMap) {
        aanvraagCoordinaten = {
            lat: Number(infrastructuurAanvraagCoordinaten.lat),
            lng: Number(infrastructuurAanvraagCoordinaten.lng)
        };
    }

    if (!model && !model.lengtegraad && !model.breedtegraad) {
        model.breedtegraad = model.breedtegraad.toString();
        model.lengtegraad = model.lengtegraad.toString();
    }

    const markersToShow = [{
        lat: parseFloat(mapNewCoords.lat),
        long: parseFloat(mapNewCoords.lng),
        size: 'x-large',
        color: types.COLOR_BLUE,
        draggable: mapEditMode,
        onDragEnd: onMarkerDragEnd
    }];

    const mijnProjectMarkers = [<Markers key="theMarkers" markersToShow={markersToShow} />, <Circle key="theCircle" center={center} color="red" radius={600} fillOpacity={0} />];

    return (<Section title={"Vul het antwoord op onderstaande vragen in"} color={color}>
        <Form
            title={formTitle}
            name={"InfrastructuurDetail"}
            leftButtonLabel={"Annuleer"}
            onLeftButtonClick={onCancel}
            leftButtonDisabled={mapEditMode}
            rightButtonLabel={"Bewaar"}
            onRightButtonClick={onSave}
            rightButtonDisabled={mapEditMode}>
            <Fieldset>
                <Row>
                    <TextInput
                        name={"naam"}
                        label={"Naam"}
                        value={model.naam}
                        onChange={onChange}
                        maxLength={300}
                        validationMessage={errors ? errors.naam : ''}
                        validationMessageType={validationMessageType}
                        disabled={isSpakki}
                        size={12}
                    />
                </Row>
                <Row>
                    <SelectInput
                        name={"soortInfrastructuurId"}
                        label={"Soort infrastructuur"}
                        onChange={onChange}
                        value={model.soortInfrastructuurId}
                        validationMessage={errors ? errors.soortInfrastructuurId : ''}
                        validationMessageType={validationMessageType}
                        disabled={isSpakki}
                        size={model.soortInfrastructuurId != domainConstants.ANDERE_INFRASTRUCTUUR_GUID ? 12 : 6}
                        items={soortenInfrastructuurList}
                    />
                    {model.soortInfrastructuurId != domainConstants.ANDERE_INFRASTRUCTUUR_GUID ||
                        <TextInput
                            name={"andereInfrastructuur"}
                            label={"Andere infrastructuur"}
                            value={model.andereInfrastructuur}
                            onChange={onChange}
                            maxLength={200}
                            validationMessage={errors ? errors.andereInfrastructuur : ''}
                            validationMessageType={validationMessageType}
                            size={6}
                        />
                    }
                </Row>
                <Row>
                    <TextInput
                        name={"straatHuisnummer"}
                        label={"Straat en huisnummer"}
                        value={model.straatHuisnummer}
                        onChange={onChange}
                        maxLength={200}
                        validationMessage={errors ? errors.straatHuisnummer : ''}
                        validationMessageType={validationMessageType}
                        size={12}
                    />
                </Row>
                <Row>
                    <Dropdown
                        name={"postcode"}
                        label={"Postcode"}
                        value={model.postcode}
                        onChange={onChange}
                        validationMessage={errors ? errors.postcode : ''}
                        validationMessageType={validationMessageType}
                        size={4}
                        items={postcodes}
                        noResultsMessage="Tik (2 cijfers) en zoek"
                        disabled={false}
                    />
                    <Dropdown
                        name={"gemeente"}
                        label={"Gemeente"}
                        onChange={onChange}
                        value={model.gemeente}
                        size={8}
                        items={gemeenten}
                        validationMessage={errors ? errors.gemeente : ''}
                        validationMessageType={validationMessageType}
                        disabled={false}
                    />
                </Row>
                <Row>
                    <Button
                        onClick={onGetGeoCoordinates}
                        text={"Positioneer infrastructuur op de kaart"}
                        className={"o-col-4"}
                        disabled={mapEditMode}
                        style={{ marginLeft: '0.8333%', marginRight: '0.8333%' }}
                    />
                    <TextInput
                        name={"breedtegraad"}
                        label={"Breedtegraad"}
                        onChange={onChange}
                        value={model.breedtegraad}
                        validationMessage={errors ? errors.breedtegraad : ''}
                        validationMessageType={validationMessageType}
                        size={4}
                        disabled
                    />
                    <TextInput
                        name={"lengtegraad"}
                        label={"Lengtegraad"}
                        onChange={onChange}
                        value={model.lengtegraad}
                        validationMessage={errors ? errors.lengtegraad : ''}
                        validationMessageType={validationMessageType}
                        size={4}
                        disabled
                    />
                </Row>
                <Row>
                    <div>
                        {infrastructuurAanvraagCoordinaten && infrastructuurAanvraagCoordinaten.lat !== "" ?
                            <div>
                                <Row>
                                    <Map
                                        mapName={mapKey}
                                        geoToolboxUrl={geoToolboxUrl}
                                        maxMapFeaturesToLoad={maxMapFeaturesToLoad}
                                        baseLayerUrl={osmBaseLayerUrl}
                                        baseLayerAttribution='&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors, Tiles courtesy of <a href="https://geo6.be/">GEO-6</a>'
                                        children={mijnProjectMarkers}
                                        zoom={15}
                                        showEmptyMap
                                        hideLegende
                                        onlyBaseLayers
                                        customCenter={aanvraagCoordinaten}
                                    />
                                </Row>
                                <Row>
                                    <br />
                                    {mapEditMode === false ?
                                        <span>
                                            <Button
                                                onClick={onReplacePoint}
                                                text={'Wijzig de ligging op de kaart'}
                                            />
                                            <Tooltip
                                                text={wijzigMapTooltip}
                                                iconColor={types.COLOR_BLUE_DARK}
                                                tooltipType={types.TOOLTIP_INFO}
                                                windowWidth={35}
                                                windowAlignRight={false} />
                                        </span>
                                        : ''}
                                    {mapEditMode === true ?
                                        <span>
                                            <Button
                                                onClick={onSaveNewPoint}
                                                text={'Bewaar locatie'}
                                            />
                                            <Button
                                                onClick={onCancelReplace}
                                                text={'Annuleer'}
                                            />
                                        </span>
                                        : ''}
                                </Row>
                            </div>
                            :
                            null
                        }
                    </div>
                </Row>
            </Fieldset>
        </Form>
    </Section >);
};

SimulatiePerInfrastructuurEditInfrastructuurForm.propTypes = {
    color: PropTypes.string.isRequired,
    model: PropTypes.object.isRequired,
    isNew: PropTypes.bool,
    isSpakki: PropTypes.bool,
    mapKey: PropTypes.string.isRequired,
    mapEditMode: PropTypes.bool.isRequired,
    mapCenter: PropTypes.object.isRequired,
    mapNewCoords: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onReplacePoint: PropTypes.func.isRequired,
    onSaveNewPoint: PropTypes.func.isRequired,
    onCancelReplace: PropTypes.func.isRequired,
    onGetGeoCoordinates: PropTypes.func.isRequired,
    soortenInfrastructuur: PropTypes.array.isRequired,
    gemeenten: PropTypes.array.isRequired,
    postcodes: PropTypes.array.isRequired,
    errors: PropTypes.object,
    center: PropTypes.object.isRequired,
    maps: PropTypes.object,
    map: PropTypes.object,
    infrastructuurAanvraagCoordinaten: PropTypes.object,
    hideAndereSoortInfrastructuur: PropTypes.bool,
    geoToolboxUrl: PropTypes.string,
    maxMapFeaturesToLoad: PropTypes.string,
    osmBaseLayerUrl: PropTypes.string,
    onMarkerDragEnd: PropTypes.func,
    validationMessageType: PropTypes.string
};

export default SimulatiePerInfrastructuurEditInfrastructuurForm;